import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME, EXPORT_FILE_NAME } from './constants';

class OutSourcingDetailProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	async GetWarehouse(Ids: any) {
		return this.fetch('/DropdownList/GetWarehouse/', { WorkShopId: Ids });
	}

	async GetOutSourcingDetail(outSourcingUrlParameters: any, languageId:any, columnsSeq: any) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/${NAME}/GetOutSourcingDetailsReport?${outSourcingUrlParameters}&ColumnSequence=${columnsSeq}&LanguageId=${languageId}`, EXPORT_FILE_NAME);
	}
}
export const apiProvider = new OutSourcingDetailProvider();
